import { h } from "@stencil/core";
import { createContext } from '../../utils/createContext';
const { Provider, Consumer } = createContext({ defaultValue: 'first-level' });
export class MyComponent {
    constructor() {
        this.firstLevel = { defaultValue: 'first-level' };
        setTimeout(() => {
            this.firstLevel = { defaultValue: 'first-level-updated-2sec' };
        }, 2000);
    }
    render() {
        return (h(Provider, { value: this.firstLevel },
            h(Consumer, null, ({ defaultValue }) => (h("div", null,
                h("div", null,
                    "1. ",
                    defaultValue),
                h("my-component-child", null))))));
    }
    static get is() { return "my-component"; }
    static get states() { return {
        "firstLevel": {}
    }; }
}
